module.exports = __webpack_public_path__ + "media/images/bsmart/icons/icon_calendar-7a18ee29dce99826d23add0aa62e9c76.svg";